import { useNavigate, useRouteError } from "react-router-dom";
import { NavigateToHome } from "../../Utils/Utils";

export default function NoAccesPage() {
  const error = useRouteError();
  console.error(error);
  const navigate = useNavigate();
  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <h1 className="font-mtn mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Access non autorisé
        </h1>
        <p className="mt-6 text-base leading-7 text-gray-600">
          Désolé, vous n'avez pas acces à l'application.
        </p>
        <div className="mt-3 flex items-center justify-center gap-x-6">
          <button
            onClick={() => {
              navigate(NavigateToHome());
            }}
            className="border-none shadow-none btn btn-sm bg-main "
          >
            Retour
          </button>
        </div>
      </div>
    </main>
  );
}
